var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcorrenciaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 7C2.11341 7 1.66675 7.44667 1.66675 8C1.66675 8.55333 2.11341 9 2.66675 9C3.22008 9 3.66675 8.55333 3.66675 8C3.66675 7.44667 3.22008 7 2.66675 7ZM2.66675 3C2.11341 3 1.66675 3.44667 1.66675 4C1.66675 4.55333 2.11341 5 2.66675 5C3.22008 5 3.66675 4.55333 3.66675 4C3.66675 3.44667 3.22008 3 2.66675 3ZM2.66675 11C2.11341 11 1.66675 11.4533 1.66675 12C1.66675 12.5467 2.12008 13 2.66675 13C3.21341 13 3.66675 12.5467 3.66675 12C3.66675 11.4533 3.22008 11 2.66675 11ZM4.66675 12.6667H14.0001V11.3333H4.66675V12.6667ZM4.66675 8.66667H14.0001V7.33333H4.66675V8.66667ZM4.66675 3.33333V4.66667H14.0001V3.33333H4.66675Z",
    fill: "#66686D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcorrenciaIcon);
export default __webpack_public_path__ + "static/media/ocorrencia-icon.86242047.svg";
export { ForwardRef as ReactComponent };